<svelte:head>

    <link rel='stylesheet' href='/global.css' />

</svelte:head>

<script>

    import api, {
        getMembersList,
        getPayoutsList,
        createPayout,
        getExpenseSettings,
        updateExpenseSettings
    } from "../api.svelte";
    import {checkUnauthorized} from "../../utils/session";
    import {getContext, onMount} from "svelte";

    import Easepick from '../lib/easepick-svelte/Easepick.svelte'
    import dayjs from "dayjs";



    const router = getContext('router');

    let currentOverlay = 'none';
    let currentView = 'completed'

    let expenses = {};
    let expensErrore = false;
    let errorResetTimer = null;

    export const ERROR_DISAPPEAR_AFTER = 5500;

    let selection = [];

    let payoutsList = [];
    let memberIdList = [];

    let payoutCreateLoading = false;

    let calendarContainer;
    let calendarLitepicker;

    let easepickIsShown;

    let dateRange = {
        'start': 0,
        // 'start': parseInt(new Date(new Date().setMonth(new Date().getMonth() - 1)).getTime() / 1000),
        'end': parseInt(new Date().getTime() / 1000),
    };

    let triggerCalendar = () => {

        calendarLitepicker.open();
        easepickIsShown = true;

    };

    let closeCalendar = () => {

        if (easepickIsShown) {
            calendarLitepicker.close();
            easepickIsShown = false;
        }

    };

    let startErrorResetTimer = () => {

        if (errorResetTimer) {

            clearTimeout(errorResetTimer);
        }

        errorResetTimer = setTimeout(() => {

            expensErrore = false;

        }, ERROR_DISAPPEAR_AFTER);

    };

    let changeOverlay = (mode) => {

        currentOverlay = mode;
    };

    onMount(() => {

        assembleData();

    });

    let assembleData = () => {

        let payouts;
        let members;

        payoutsList = [];
        memberIdList = [];

        console.log(dateRange)

        handleGetExpenseSettings();

        handleGetPayouts().then((res) => {

            payouts = res['payouts'];

            console.log(payouts)

            handleGetMembers().then((response) => {

                console.log(response['members'])

                members = response['members'];

                console.log(members)

                if (!payouts || !members) {

                    console.log('failed');

                    return;
                }

                for (const [idx, payout] of Object.entries(payouts)) {

                    memberIdList.push(idx)

                    let amount = 0;

                    for (const [i, transaction] of Object.entries(payout['transactions'])) {

                        amount += transaction['amount']
                    }

                    for (const [x, member] of Object.entries(members)) {

                        console.log(member);

                        if (idx !== member['id']) {

                            continue;
                        }

                        if (!('iban' in member['settings']) || !('number' in member['company']['address'])) {

                            continue;
                        }



                        let whatever = {
                            'payoutid': payouts[idx]['id'],
                            'memberid': idx,
                            'amount': amount,
                            'transactions': payouts[idx]['transactions'],
                            'membername': member['company']['name'],
                            'lastpayout': member['payout']
                        };

                        payoutsList.push(whatever);

                        selection.push(idx)

                    }
                }

                payoutsList = payoutsList;
                memberIdList = memberIdList;
                console.log(payoutsList);
                // console.log(payoutsList[0]['lastpayout'].size)

                console.log(payoutsList);
            })
        });

    }

    let handleGetMembers = async () => {

        let result = await getMembersList();

        if (result['status'] !== 'success') {

            checkUnauthorized(router, result);
            console.log(result);

            return false;
        }

        return result;
    }

    let handleGetPayouts = async () => {

        let result = await getPayoutsList(dateRange);

        if (result['status'] !== 'success') {

            checkUnauthorized(router, result);
            console.log(result);

            return false;
        }

        return result;
    }

    let handleGetExpenseSettings = () => {

        getExpenseSettings().then((result) => {

            if (result['status'] !== 'success') {

                checkUnauthorized(router, result);
                console.log(result);

                return false;
            }

            if ('num' in result['settings']) {

                expenses = result['settings'];
            }

        });
    }

    let handleUpdateExpenseSettings = () => {

        if (!('num' in expenses)) {

            expensErrore = true;
            startErrorResetTimer();

            return;
        }

        updateExpenseSettings(expenses).then((result) => {

            if (result['status'] !== 'success') {

                checkUnauthorized(router, result);
                console.log(result);
                return;

            }

            assembleData();

        });

    }


    let calendarDatesSelected = (evt) => {

        dateRange['start'] = parseInt(new Date(evt.detail['startDate']).getTime() / 1000);
        dateRange['end'] = parseInt(new Date(evt.detail['endDate']).getTime() / 1000);

        assembleData();
    };

    let checkAll = () => {

        selection = memberIdList;
    }

    let handleCreatePayout = () => {

        if (!('num' in expenses)) {

            expensErrore = true
            startErrorResetTimer();

            return;
        }

        createPayout(dateRange, selection).then((resp) => {

            if (resp['status'] !== 'success') {

                checkUnauthorized(router, resp);
                console.log(resp);
                return;

            }

            window.open('https://prod-api.dublonen.ch/aemtlerbon' + '/admin/payout/file?payoutid=' + resp['payoutid'], '_blank')

            changeOverlay('none');
            assembleData();

        })

    }

    $: getTotalSelected = () => {

        let total = 0;

        for (const [idx, payout] of Object.entries(payoutsList)) {

            if (selection.includes(payout['memberid'])) {

                total += payout['amount'];
            }
        }

        return total
    }

    $: getTotal = () => {

        let total = 0;

        for (const [idx, payout] of Object.entries(payoutsList)) {

            for (const [i, transaction] of Object.entries(payout['transactions'])) {

                total += transaction['amount'];

            }

        }

        return total
    }

</script>

<div id="payout-container">

    <div id="header">

        <h1>Auszahlungen</h1>

        <button
                id="payout-create"
                on:click={() => changeOverlay('create')}
                class="btn entity-save">

            <span>Auszahlung erstellen</span>

        </button>

    </div>

    {#if currentOverlay === 'none'}

        <div class="payout-wrapper">

            <div id="payout-list">

                <div id="list-datepicker-container">

                    <img
                            src="images/icons/icon-calendar.svg"
                            on:click|self={() => triggerCalendar()} />

                    <div
                            id="calendar-container"
                            bind:this={calendarContainer}
                            style="display: none;">

                        <Easepick
                                bind:this={calendarLitepicker}
                                bind:element={calendarContainer}
                                on:selected={calendarDatesSelected}
                                calendars={2}
                                firstDay={1}
                                autoApply={false}
                                startDate={dayjs.unix(parseInt(new Date(new Date().setMonth(new Date().getMonth() - 1)).getTime() / 1000)).format('YYYY-MM-DD')}
                                endDate={dayjs.unix(dateRange['end']).format('YYYY-MM-DD')}
                                css={['/css/easepick.css']}
                        />

                    </div>

                </div>

                <div id="list-total-container">

                    <span>Total offener Betrag: CHF {getTotal()}.00</span>

                </div>

                <table>

                    <tr class="header-row">

                        <th id="list-company">Firma</th>
                        <th id="list-payout">letze Auszahlung</th>
                        <th id="list-amount">Betrag</th>
                        <th class="checkbox-input"><input type="checkbox" id="select-all" on:click={() => checkAll()}/><label for="select-all">Alle Auswählen</label></th>

                    </tr>

                    {#each Object.values(payoutsList) as payout}

                        <tr>
                            <td>{payout['membername']}</td>
                            <td>{Object.keys(payout['lastpayout']).length === 0 ? 'Noch nie' : dayjs.unix(payout['lastpayout'][payout['memberid']]).format('DD.MM.YY')}</td>
                            <td>CHF {payout['amount']}.00</td>
                            <td class="checkbox-input"><input checked type="checkbox" bind:group={selection} value={payout['memberid']}/></td>
                        </tr>

                        <tr>

                            <td colspan="3">

                                <div class="transaction-container">

                                    {#each Object.values(payout['transactions']) as trx}

                                        <div class="transaction-sublist">

                                            <div style="width: 16vh;">
                                                <div>Sub-transaktion</div>
                                            </div>

                                            <div style="width: 16vh">
                                                <div>Erstellt {dayjs.unix(trx['created']).format('DD.MM.YY')}</div>
                                            </div>

                                            <div>
                                                <div>CHF {trx['amount']}.00</div>
                                            </div>

                                        </div>

                                    {/each}

                                </div>
                            </td>

                        </tr>

                        <tr>
                            <td colspan="4">
                                <hr>
                            </td>
                        </tr>



                    {/each}


                </table>
            </div>

            <div class="expenses-container">

                <div class="assistant-container">

                    <div class="section-title">Abzug Mitglieder</div>

                    <div class="expenses-input">
                        <input
                                bind:value={expenses['num']}
                                type="number"
                                placeholder="" />

                        <span>%</span>
                    </div>

                    {#if expensErrore}
                        <span class="errore">Bitte Feld ausfüllen.</span>
                    {/if}

                    <button on:click={() => handleUpdateExpenseSettings()} class="btn entity-add">Speichern</button>

                </div>

                <div class="assistant-container">

                    <div class="section-title">Abzug Externe</div>

                    <div class="expenses-input">
                        <input
                                bind:value={expenses['external']}
                                type="number"
                                placeholder="" />

                        <span>%</span>
                    </div>

                    {#if expensErrore}
                        <span class="errore">Bitte Feld ausfüllen.</span>
                    {/if}

                    <button on:click={() => handleUpdateExpenseSettings()} class="btn entity-add">Speichern</button>

                </div>

            </div>


            </div>



    {/if}

</div>

{#if currentOverlay === 'create'}

    <div
            id="assistant-create"
            class="assistant"
            on:click|self={() => currentOverlay = 'none'}>

        <div class="assistant-container">

            <div
                    on:click={() => changeOverlay('none')}
                    class="assistant-close">

                <img src="images/icons/close.svg" alt="Close" />

            </div>

            <div id="payouts">
                
                <table>

                    {#each Object.values(payoutsList) as payout}

                        {#if selection.includes(payout['memberid'])}

                            <tr>
                                <td>{payout['membername']}</td>
                                <td>{payout['amount']}.- CHF</td>
                            </tr>



                        {/if}

                    {/each}


                    <tr class="spacer"></tr>

                    <tr id="selected-total-amount">
                        <td></td>
                        <td>Total: {getTotalSelected()}.- CHF</td>
                    </tr>
                </table>
                
            </div>

            <button
                    on:click={() => handleCreatePayout()}
                    class="{(payoutCreateLoading) ? 'loading btn' : 'btn'}">

                <span>Bestätigen & File Herunterladen</span>
                <img src="images/loader/button-loader.svg" />

            </button>

        </div>

    </div>

{/if}

<style>

    #payout-container {
        position: relative;
        display: flex;
        flex-direction: column;
        width: calc(100vw - 40vh);
        padding-top: 4vh;
    }

    #payout-list {
        position: relative;
        display: flex;
        flex-direction: column;
        align-self: center;
        align-items: center;
        width: fit-content;
        min-height: 50vh;
        padding: 4vh;
        border-radius: 1.5vh;
        font-family: 'Urbanist', sans-serif;
        background-color: #FFFFFF;
        -webkit-box-shadow: 0px 3px 10px 0px rgba(73, 119, 172, 0.08);
        -moz-box-shadow: 0px 3px 10px 0px rgba(73, 119, 172, 0.08);
        box-shadow: 0px 3px 10px 0px rgba(73, 119, 172, 0.08);
    }

    #list-datepicker-container {
        position: absolute;
        top: 3vh;
        left: 3vh;
    }

    #list-total-container {
        position: absolute;
        top: 3vh;
        right: 3vh;
        height: 3vh;
        display: flex;
        align-items: center;
    }

    #list-total-container span {
        font-weight: 600;
        font-size: 1.5vh;
    }

    #calendar-container {
        top: 100%;
        left: 0;
    }

    img {
        height: 3vh;
        transition: all 0.3s ease;
        cursor: pointer;
    }

    table {
        margin-top: 6vh;
        border-spacing: 0;
        border-collapse: collapse;
    }

    table tr {
        transition: all 0.2s ease;
        position: relative;
    }

    table tr:not(.header-row):not(#total-amount):hover {
        cursor: pointer;
        background-color: rgba(123, 194, 255, 0.075);
    }

    table th, table td {
        padding: 0.75vh;
        text-align: center;
        font-size: 1.5vh;
    }

    table th {
        font-weight: 500;
        width: 10vh;
    }

    table td:last-child, table th:last-child {
        text-align: left;
    }

    th#list-payout, th#list-company {
        width: 16vh;
    }

    table tr td.full_length {
        width: 100%;
    }

    .checkbox-input input {
        height: 1.2vh;
        width: 1.2vh;
    }

    .assistant {
        width: calc(100vw - 28vh);
        height: 100vh;
    }

    .assistant-container button {
        margin-bottom: 0;
    }

    #payouts table {
        margin-top: unset;
        margin-bottom: 3vh;
    }

    .spacer {
        height: 2vh;
    }

    #selected-total-amount {
        border-top: 1px solid black;
    }

    .payout-wrapper {
        display: flex;
        margin-top: 12vh;
        justify-content: space-evenly;
    }

    .section-title {
        width: 28vh;
        margin-bottom: 1vh;
        font-weight: 500;
        font-size: 1.75vh;
        font-family: 'Urbanist', sans-serif;
    }

    .assistant-container input {
        width: 15vh;
        padding: 1.42vh;
        margin-bottom: 2.5vh;
        font-size: 1.78vh;
    }

    .assistant-container button {
        width: 28vh;
        padding: 1.42vh;
        margin-bottom: 0;
        font-size: 1.78vh;
    }

    .expenses-container {
        display: flex;
        flex-direction: column;
    }

    .expenses-container .assistant-container {
        margin-bottom: 2vh;
    }

    .expenses-input span {
        font-size: 1.78vh;
        font-family: 'Urbanist', sans-serif;
    }

    .expenses-input input {
        width: 10vh;
    }

    .errore {
        font-size: 1.78vh;
        font-family: 'Urbanist', sans-serif;
        color: red;
    }

    .entity-save {
        padding: 1vh 1.5vh;
        font-size: 1.78vh;
    }

    .transaction-container {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .transaction-container .transaction-sublist {
        display: flex;
        width: 100%;
        justify-content: space-around;
    }

    .transaction-container .transaction-sublist div {
        width: 10vh;
        display: flex;
        justify-content: center;
    }

    .transaction-container .transaction-sublist div div {
        display: flex;
        font-size: 1.2vh;
    }





</style>